import axiosInstance from '../../../helpers/backend_helper';

const getAllBookEpisodes = async (bookId) => {
  try {
    const response = await axiosInstance.get(`episodes/by-story/${bookId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching episodes for book with ID ${bookId}:`, error);
    throw error;
  }
};

export default getAllBookEpisodes;
